// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";

function kindToHeaderText(kind) {
  switch (kind) {
    case "Transport" :
      return I18n.t("Transport U. fees");
    case "Taxes" :
      return I18n.t("Taxes U. fees");
    case "Other" :
      return I18n.t("Other U. fees");
  }
}

function getFeesRowData(productFees, cartFees) {
  if (cartFees !== undefined) {
    return cartFees.map(cartFee => {
      let match_ = productFees.find(fee => fee.kind === cartFee.kind);
      if (match_ !== undefined) {
        return I18n.currencyFormat(undefined, "EUR", 3, 3, match_.amount);
      } else {
        return "";
      }
    });
  } else {
    return [""];
  }
}

function formattedTaxRates(productTaxes) {
  return Stdlib_Array.reduce(productTaxes, "", (acc, tax) => acc + (
    acc !== "" ? ", " : ""
  ) + I18n.percentFormat(undefined, undefined, 2, tax.rate / 100));
}

export {
  kindToHeaderText,
  getFeesRowData,
  formattedTaxRates,
}
/* I18n Not a pure module */
